import createHash from 'hash-generator';

export const generateHash = (length: number = 12): string => {
    return createHash(length);
};